import { render } from "./WordView.vue?vue&type=template&id=43b9f1b8&scoped=true&ts=true"
import script from "./WordView.vue?vue&type=script&lang=ts"
export * from "./WordView.vue?vue&type=script&lang=ts"

import "./WordView.vue?vue&type=style&index=0&id=43b9f1b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b9f1b8"]])

export default __exports__